<template>
  <div class="job-list">
    
    <div v-for="(item, index) in listData" class="job-content flex-start" :key="index" @click="toRecommendDetail(item)" :class="[source === 'jobDetail' && index !== listData.length - 1 ? 'add-border' : '', source === 'jobDetail' ? 'add-padding' : '']">
      <div v-if="options.isSelect" class="select-icon-container">
        <i class="iconfont" :class="selectJobSet.has(item.token) ? 'iconxuanzhong' : 'iconweixuanzhong'"></i>
      </div>
      <div class="recommend-item" data-growing-container :style="{'padding-bottom' : (!!jobListAdBean && ((index === 3 && jobListAdBean.page_type==='cvs') || (index === 4 && jobListAdBean.page_type==='jobs'))) ? '0px' : '18px'}">
        <div class="recommend-desc flex-column">

          <!-- 职位名和薪资 -->
          <div class="company">
            <span class="job-post" style="float: left">
              {{ item.job_post }}
            </span>
            <!-- <span v-if="(item.origin_source === 'jd' || item.source === 'jd') &#38;&#38; !item.direct_interview"> -->

            <!-- <span v-if="!!jobTag(item).url">
              <img :src="jobTag(item).url" :class="jobTag(item).class"/>
            </span> -->

            <!-- <span v-if="item.priority &#38;&#38; (item.priority === 1) &#38;&#38; !item.direct_interview"> -->
            <!--   <img src="https://files.wondercv.com/jobs-card/hr-online-blue.png" class="hr-talk-blue"/> -->
            <!-- </span> -->
            <!-- <span v-if="item.direct_interview &#38;&#38; item.origin_source !== 'admin' &#38;&#38; item.source !== 'admin'"> -->
            <!--   <img src="https://files.wondercv.com/jobs-card/offer-jobs.png" class="hr-talk"/> -->
            <!-- </span> -->
            <!-- <span v-if="item.priority &#38;&#38; (item.priority > 1) &#38;&#38; !item.direct_interview"> -->
            <!--   <img src="https://files.wondercv.com/jobs-card/Engage.png" class="hr-talk"/> -->
            <!-- </span> -->

            <span class="salary" style="float: right;margin-top: 3px">{{ (item.annual_month_salary && item.annual_month_salary > 12) ? `${item.display_salary} · ${item.annual_month_salary}薪` : `${item.display_salary}` }}</span>
          </div>

          <!-- tag -->
          <div class="tag-els flex-start">
            <div class="tag-content-main">

              <div class="tag-content">
                <p class="city-work-job flex-center" v-if="item.job_nature === '校招'">{{ item.job_nature }}</p>
                <p class="city-work-job flex-center" v-if="item.job_nature === '校招'">{{ item.graduate_times | formatGraduationYear }}</p>
                <!-- 经验要求 -->
                <p class="city-work-job flex-center" v-if="item.job_nature === '全职'">{{ item.display_experience | experienceFilter }}</p>
                <!-- 学历要求 -->
                <p class="city-work-job flex-center">{{ item.degree_name | degreeFilter }}</p>
                <!-- 周实习天数 -->
                <p class="city-work-job flex-center" v-if="item.intern_frequency && item.job_nature==='实习'">{{ item.intern_frequency }}天/周</p>
                <!-- 最少实习月数 -->
                <p class="city-work-job flex-center" v-if="item.intern_duration && item.job_nature==='实习'">{{ item.intern_duration }}</p>
                <!-- 职位关键词 -->
                <p class="city-work-job flex-center" v-for="(val, tagIndex) in (item.job_tags || [])" :key="tagIndex">{{val}}</p>
              </div>

            </div>
          </div>

          <!-- 公司logo及信息 -->
          <div class="flex-start company-info">
            <div class="flex-start">
              <img class="company-logo" :src="item.company_logo" alt="">
              <span class="company-name">{{ item.company_nick_name ||  item.company_name }}</span>
              <span class="separator" v-if="item.company_industry"></span>
              <span class="company-industry">{{ item.company_industry }}</span>
              <span class="separator" v-if="item.company_scale"></span>
              <span class="company-scale">{{ item.company_scale }}</span>
            </div>
            <!-- <span class="company-city">{{item.city_names && item.city_names.length ? item.city_names[0] : '全国'}}</span> -->
          </div>

        </div>

        <!-- 创建时间 状态 -->
        <!-- <div class="flex-between">
          <p v-if="item.created_at" class="created_at">投递于：{{item.created_at}}</p>
          <p v-else></p>
          <p v-if="item.status === 'delivery'" class="deliver_status bgf9">已投递</p>
          <p v-else-if="item.status === 'viewed'" class="deliver_status bgf9">已查看</p>
          <p v-else-if="item.status === 'communicated'" class="deliver_status bgf5">沟通中</p>
          <p v-else-if="item.status === 'appointment'" class="deliver_status bgf5">已约面</p>
          <p v-else-if="item.status === 'unsuited'" class="deliver_status bgf9">不合适</p>
        </div> -->

        <!-- 投递状态卡片 -->
        <job-delivery-status :status="item.status" v-if="item.status"></job-delivery-status>

        <div v-if="options.isRecommendText && item.recommend_source" class="recommend-text-container">
          <p class="job-desc-text flex-start" v-if="item.recommend_source === '1' || (Number(item.match_score) < 50 && item.recommend_type === '3')">
            <img class="icon" src="https://files.wondercv.com/pc-cvs/%E7%BC%96%E7%BB%84%2017%E5%A4%87%E4%BB%BD%402x3.png" alt="">
            <span class="text">根据求职意向{{item.expect_job_title | recommendTextFilter}}为您推荐</span>
          </p>
          <p class="job-desc-text flex-start" v-else>
            <img class="icon" src="https://files.wondercv.com/cvs-job-pc/%E7%AE%80%E5%8E%86%E6%8E%A8%E8%8D%90%E6%A0%87%E7%AD%BE.png" alt="">
            <span class="text">该职位与您的简历匹配度为 {{item.match_score}}%</span>
          </p>
        </div>
        <div class="recommend-text" v-if="isShowRecommendLanguage">
          <img :src="(item.recommend_source === '1' || (item.match_score < 50 && item.recommend_type === '3') )? 'https://files.wondercv.com/cvs-job-pc/%E7%AE%80%E5%8E%86%E6%8E%A8%E8%8D%90%E6%A0%87%E7%AD%BE.png' : 'https://files.wondercv.com/cvs-job-pc/%E7%AE%80%E5%8E%86%E6%8E%A8%E8%8D%90%E6%A0%87%E7%AD%BE.png'" width="14" height="14">
          <span>{{(item.recommend_source === '1' || (item.match_score < 50 && item.recommend_type === '3') ) ? `根据求职意向${ recommendTextFilter(item.expect_job_title) }为您推荐` : `该职位与您的简历匹配度为${item.match_score}%`}}</span>
        </div>
        <div class="ad-layout" v-if="(!!jobListAdBean && ((index === 3 && jobListAdBean.page_type==='cvs') || (index === 4 && jobListAdBean.page_type==='jobs')))" @click.stop="onJobAdClick()">
          <img class="ad-image" :src="jobListAdBean.image"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { envMixin } from '../../assets/js/mixin/global'
import JobDeliveryStatus from './job-delivery-status.vue';

export default {
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    operationShow: {
      type: Boolean,
      default: false
    },
    showUpdate: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => {
        return {
          isSelect: false,
          isRecommendText: false,
          noResponse: false
        }
      }
    },
    isShowRecommendLanguage: {
      type: Boolean,
      default: false
    },
    jobListAdBean: {
      type: Object,
      default: () => null
    },
    source: {
      type: String,
      default: ''
    }
  },
  name: 'job-list',
  data () {
    return {
      isShowTagMore: [],
      headImgList: { //头像
        round: [ 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round1.png', 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round2.png', 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round3.png' ], // 圆图
        square: [ 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square1.png', 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square2.png', 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square3.png' ], // 方图
      },
      selectJobSet: new Set()
    }
  },
  mixins: [ envMixin ],
  mounted () {},
  computed: {
    miniType () {
      return this.$route.query.in
    }
  },
  watch: {
    listData: {
      handler () {
        this.$nextTick(() => {
          let els = document.querySelectorAll('.tag-content')
          let Booleans = JSON.parse(JSON.stringify(this.isShowTagMore))
          for (let i = Booleans.length; i < els.length; i++) {
            Booleans[i] = els[i].offsetHeight > 26
          }
          this.isShowTagMore = Booleans
        })
        if (this.options.isSelect) {
          this.selectJobSet = new Set(this.listData.map(item => item.token))
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    JobDeliveryStatus
  },

  methods: {
    toRecommendDetail (item) {
      if (this.options.noResponse) {
        return
      } else if (this.options.isSelect) {
        this.selectJobSet.has(item.token) ? this.selectJobSet.delete(item.token) : this.selectJobSet.add(item.token)
        this.$forceUpdate()
        this.$emit('changeSelectToken', Array.from(this.selectJobSet))
      } else {
        if (this.iosOrAndroid) {
          window.location.href = `/jobs/${ item.token }.html`
        } else if (this.isWxMini && this.miniType === 'job_xcx') {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/jobDetail/jobDetail?url=${ process.env.VUE_APP_HOST }/jobs/recommend/${ item.token }&companyToken=${ item.company_token }&com_name=${ item.company_name }&info_name=${ item.job_post }&in=job_xcx`
          })
        } else if (this.isWxMini) {
          let url = `/pages/job-detail/job-detail?url=${ process.env.VUE_APP_HOST }/jobs/recommend/${ item.token }&companyToken=${ item.company_token }&com_name=${ item.company_name }&info_name=${ item.job_post }`
          this.$db.ls.set('shareNeed', true)
          this.$wechat.miniProgram.navigateTo({ url })
        } else {
          this.$router.push({
            path: `/jobs/recommend/${ item.token }`,
            query: {
              companyToken: item.company_token
            }
          })
        }
      }
    },
    recommendTextFilter(val){
      if (!val) return ''
      // level3 中数组只有一个值，则为精确推荐，则展示level3中的值
      // 如果 level3 中值大于1，则随机展示 level1 中的值
      let { level1_names, level2_names, level3_names} = val
      if (level3_names && level3_names.length) {
        return `“${level3_names[0]}”`
      } else if (level2_names && level2_names.length) {
        return `“${level2_names[0]}”`
      } else if (level1_names && level1_names.length) {
        return `“${level1_names[0]}”`
      } else {
        return ''
      }
    },
    onJobAdClick() {
      console.log(this.jobListAdBean.link);
      window.open(this.jobListAdBean.link, '_blank');
    },
    jobTag(job) {
      if (job.priority && (job.priority > 1)) {
        return { url :`https://files.wondercv.com/jobs-card/Engage.png`, class: 'hr-talk'};
      } else if (job.direct_interview && job.origin_source !== 'admin' && job.source !== 'admin') {
        return { url: `https://files.wondercv.com/jobs-card/offer-jobs.png`, class: 'hr-talk' };
      } else if (job.priority && (job.priority === 1) && !job.direct_interview) {
        return { url: `https://files.wondercv.com/jobs-card/hr-online-blue.png`, class: 'hr-talk-blue' };
      } else {
        return false;
      }
    },
  },
  filters: {
    degreeFilter (val) {
      if (!val) {
        return '学历不限'
      } else if (val.includes('不限')) {
        return '学历不限'
      } else {
        return val
      }
    },
    experienceFilter (val) {
      if (!val) {
        return '经验不限'
      } else if (val.includes('不限')) {
        return '经验不限'
      }else if (val === '1年以下') {
        return '1年以内'
      } else {
        return val
      }
    },
    operationFilter (val) {
      if (val) {
        let value = ''
        switch (val) {
          case 'like':
            value = '已收藏'
            break
          case 'discard':
            value = '不感兴趣'
            break
          case 'apply':
            value = '已投递'
            break
        }
        return value
      }
    },
    recommendTextFilter(val) {
      if (!val) return ''
      // level3 中数组只有一个值，则为精确推荐，则展示level3中的值
      // 如果 level3 中值大于1，则随机展示 level1 中的值
      let { level1_names, level2_names, level3_names} = val
      if (level3_names && level3_names.length) {
        return `“${level3_names[0]}”`
      } else if (level2_names && level2_names.length) {
        return `“${level2_names[0]}”`
      } else if (level1_names && level1_names.length) {
        return `“${level1_names[0]}”`
      } else {
        return ''
      }
    },
    formatGraduationYear (yearArr) {
      if (!yearArr || !yearArr.length) return ''
      let newArr = yearArr.map(item => {
        return String(item).substring(2)
      })
      return newArr.join('/') + '届'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global/variable';
@import '@/assets/scss/jobs/recommend-list';
.job-list {
  width: 100%;
}
.recommend-text{
  border-top: 1px solid #f9f9f9;
  font-size: 14px;
  font-weight: 400;
  color: #9C9C9C;
  padding: 13px 0 0px 0;
  display: flex;
  align-items: center;
  margin-top: 14px;
  &>img{
    margin-right: 6px;
  }
}
.ad-layout{
  width: 375px;
  background-color: #f9f9f9;
  padding: 12px 26px 6px 26px;
  margin-left: -26px;
  margin-top: 13px;
  .ad-image{
    height: 90px;
    object-fit: cover;
    border-radius: 8px;
    min-width: 100%;
  }
}
.ad-padding1{
  padding-bottom: 0px;
}

.add-border {
  border-bottom: 6px solid #f9f9f9;
}

.add-padding {
  padding: 0 16px;
}
.recommend-item{
  width: 343px;
  margin: 12px auto 0 auto;
  border-radius: 8px;
  padding: 10px 15px !important;
}
.border-bt{
  padding-bottom: 10px;
  border-bottom: 1px solid #ECECEC;
}
.flex-between{
  padding: 10px 0 0 0;
}
.created_at{
  font-size: 13px;
  color: #9C9C9C;
}
.deliver_status{
  width: 56px;
  height: 22px;
  border-radius: 12px;
  text-align: center;
  font-size: 12px;
  line-height: 22px;
}
.bgf9{
  background: #f9f9f9;
  color: #9c9c9c;
}
.bgf5{
  background: #F5F8FF;
  color: #4183FF;
}
</style>
